export interface IBreadcrumbItem {
    url: string;
    name: string;
    image?: string;
}

type ILocalizedBreadcrumbItem = Record<string, IBreadcrumbItem>;

export interface IJsonLdData {
    breadcrumbs?: ILocalizedBreadcrumbItem[];
}

function getLocalizedBreadcrumbs(
    breadcrumbs: ILocalizedBreadcrumbItem[],
    locale: string,
): IBreadcrumbItem[] {
    return breadcrumbs.map((item) => item[locale]).filter(Boolean);
}

export function generateJsonLd(data: IJsonLdData, locale: string): string {
    const jsonLd: Record<string, unknown> = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
    };

    if (data.breadcrumbs) {
        const localizedBreadcrumbs = getLocalizedBreadcrumbs(data.breadcrumbs, locale);
        jsonLd.breadcrumb = {
            '@type': 'BreadcrumbList',
            'itemListElement': localizedBreadcrumbs.map((item, index) => ({
                '@type': 'ListItem',
                'position': index + 1,
                'item': {
                    '@id': item.url,
                    'name': item.name,
                    'image': item.image,
                },
            })),
        };
    }

    return JSON.stringify(jsonLd, null, 2);
}
